import { taxonomiesConfig } from 'config'
import { TaxonomyId, TaxSlice } from 'types'
import createTaxSlice from './createTaxSlice'

const taxSlices = taxonomiesConfig.reduce((slices, c) => {
  return slices.concat(createTaxSlice(c))
}, [] as TaxSlice<TaxonomyId>[])

export const getTaxonomyReducers = () => {
  return taxSlices.reduce(
    (reducers, slice) => {
      return {
        ...reducers,
        [slice.name]: slice.reducer,
      }
    }, {} as { [P in TaxonomyId]?: TaxSlice<P>['reducer'] }
  )
}

export default taxSlices
